module.exports = __webpack_public_path__ + "static/media/Bottom-Banner.113537c4.jpg";